export enum WarningMessages {
	NO_VALID_PLACEHOLDERS = 'No valid bestfit placeholders found',
	INVALID_STUDY_ID = 'Invalid study id set',
	OPENING_POPUP_WHILE_NO_FIT = 'Opening bestfit while no fit calculated',
	INVALID_WIDGET_TYPE = 'Invalid widget type set',
	CALCULATE_FIT_WHILE_NOT_LOGGED_IN = 'Try to calculate fit while not logged in',
	CALCULATE_FIT_WHILE_COMPLETENESS_NOT_100 = 'Try to calculate fit while completeness is not 100',
}
